// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"542f59e6","494":"60b80391","622":"2f757ed2","932":"6f78a32d"}[chunkId] + ".chunk.js";
};